import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "./api";
import { useAuth } from "./auth";
import useCaseEvents from "./useCaseEvents";

/**
 * WhatsApp-artiger Zähler für neue Einreichungen (Admin/Backoffice).
 * Live via WebSocket; auf /dashboard gilt alles als gesehen (Auto-Reset).
 */
export default function useUnseenOrders() {
  const { user } = useAuth();
  const location = useLocation();
  const [count, setCount] = useState(0);
  const isAdmin = !!user && ["admin", "backoffice"].includes(user.role);
  const onDashboard = location.pathname === "/dashboard";

  const refresh = useCallback(async () => {
    if (!isAdmin) return;
    try {
      const { data } = await api.get("/cases/unseen-count");
      setCount(data?.count || 0);
    } catch (_) {
      // silent — nächster Tick versucht's erneut
    }
  }, [isAdmin]);

  useEffect(() => {
    if (!isAdmin) return undefined;
    let stopped = false;
    Promise.resolve().then(() => { if (!stopped) refresh(); });
    const t = setInterval(refresh, 60000);
    return () => { stopped = true; clearInterval(t); };
  }, [isAdmin, refresh]);

  useCaseEvents((evt) => {
    if (evt?.type === "orders.seen") { setCount(0); return; }
    if (String(evt?.type || "").startsWith("case.")) {
      Promise.resolve().then(refresh);
    }
  });

  // Auf dem Dashboard = "Chat geöffnet" → serverseitig als gesehen markieren.
  useEffect(() => {
    if (!isAdmin || !onDashboard || count === 0) return;
    api.post("/cases/mark-seen").catch(() => {});
    setCount(0);
  }, [isAdmin, onDashboard, count]);

  return isAdmin && !onDashboard ? count : 0;
}
